export default __webpack_public_path__ + "static/media/info_img.211eafc8.png";